import { render, staticRenderFns } from "./status-updater.vue?vue&type=template&id=54700f58&scoped=true&"
import script from "./status-updater.vue?vue&type=script&lang=js&"
export * from "./status-updater.vue?vue&type=script&lang=js&"
import style0 from "./status-updater.vue?vue&type=style&index=0&id=54700f58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54700f58",
  null
  
)

export default component.exports